module.exports = __webpack_public_path__ + "static/img/30018 (2).1a668b9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30018 (2).webp
// module id = CZJc
// module chunks = 14